module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Label":"Cancel"},"fr":{"Label":"Annuler"}}')
  delete Component.options._Ctor
}
